import { render, staticRenderFns } from "./DropdownCheckbox.vue?vue&type=template&id=4d57462f"
import script from "./DropdownCheckbox.vue?vue&type=script&lang=js"
export * from "./DropdownCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports